import { motion } from "framer-motion";
import y1 from "../Images/y1.png";
import y2 from "../Images/y2.png";
import y3 from "../Images/y3.png";
import y4 from "../Images/y4.png";
import y5 from "../Images/y5.png";
import y6 from "../Images/y6.png";
import websitelogo from "../Images/websitelogo.png"
import appdevlogo from "../Images/appdevlogo.png"
import softwaredevlogo from "../Images/softwaredevlogo.png"
import aidevlogo from "../Images/aidevlogo.png"
import ecommercelogo from "../Images/ecommercelogo.png"
import uiux from "../Images/uiux.png"
const services = [
  {
    id: 1,
    number: "01",
    title: "Website Development",
    subtitle: "for Business and Individuals",
    description:
      "We create custom, responsive websites that engage visitors and drive conversions. Our designs are tailored to your brand, ensuring a seamless user experience across all devices. With a focus on aesthetics, functionality, and performance, we build websites that not only look great but also help grow your business and maximize online success.",
    iconBg: "#FF4FE4",
    iconImg: websitelogo,
    headingColor: "text-pink-500",
    subtitleColor: "text-pink-300 italic",
    illustration: y1,
    bg:'#FF4FE4'
  },
  {
    id: 2,
    number: "02",
    title: "Application Development",
    subtitle: "for Innovative and Scalable Solutions",
    description:
      "We develop native and cross-platform mobile applications for iOS and Android, delivering high-performance, user-friendly, and scalable solutions. Our apps are designed to enhance user engagement, streamline operations, and drive business growth. Whether you need a feature-rich enterprise app or a sleek consumer-facing application, we ensure seamless functionality and an exceptional user experience.",
    iconBg: "#FF927B",
    iconImg: appdevlogo,
    headingColor: "text-orange-500",
    subtitleColor: "text-orange-300 italic",
    illustration: y2,
    bg:'#FF927B'
  },
  {
    id: 3,
    number: "03",
    title: "Software Development",
    subtitle: "for Scalable and Efficient Solutions",
    description:
      "We provide tailored software solutions to streamline your business operations, improve efficiency, and enhance productivity. Our custom-built software is designed to meet your specific needs, ensuring seamless integration with existing systems. From automation to enterprise solutions, we develop scalable and secure software that empowers your business to stay ahead in a competitive market.",
    iconBg: "#00C8C8",
    iconImg: softwaredevlogo,
    headingColor: "text-teal-400",
    subtitleColor: "text-teal-200 italic",
    illustration: y3,
    bg:'#74D9C3'
  },
  {
    id: 4,
    number: "04",
    title: "AI Development",
    subtitle: "for Intelligent and Automated Solutions",
    description:
      "We create intelligent solutions powered by machine learning and artificial intelligence to enhance automation, decision-making, and efficiency. Our AI-driven applications help businesses analyze data, optimize processes, and deliver personalized user experiences. From chatbots to predictive analytics, we develop scalable and innovative AI solutions tailored to your unique needs, driving smarter business outcomes.",
    iconBg: "#B7E333",
    iconImg: aidevlogo,
    headingColor: "text-green-400",
    subtitleColor: "text-teal-200 italic",
    illustration: y4,
    bg:'#B7E333'
  },
  {
    id: 5,
    number: "05",
    title: "E-Commerce",
    subtitle: "for Seamless Online Selling and Growth",
    description:
      "We build secure, scalable online stores with seamless payment integration to enhance user experience and drive sales. Our e-commerce solutions include custom design, mobile optimization, and powerful backend management. Whether you're a startup or an established brand, we create high-performance platforms that ensure smooth transactions, customer engagement, and business growth in the digital marketplace.",
    iconBg: "#CA55FC",
    iconImg: ecommercelogo,
    headingColor: "text-purple-400",
    subtitleColor: "text-teal-200 italic",
    illustration: y5,
    bg:'#CA55FC'
  },
  {
    id: 6,
    number: "06",
    title: "UI/UX Design",
    subtitle: "for Engaging and User-Centric Experiences",
    description:
      "We create intuitive, user-centered designs that enhance user experience and engagement. Our UI/UX design services focus on seamless navigation, aesthetic appeal, and functionality to ensure a smooth and enjoyable interaction for users. From wireframes to prototypes, we craft visually stunning and responsive designs that elevate your brand and drive customer satisfaction.",
    iconBg: "#D72D2D",
    iconImg: uiux,
    headingColor: "text-purple-400",
    subtitleColor: "text-teal-200 italic",
    illustration: y6,
    bg:'#D72D2D'
  },
];

const ServiceCard = () => {
  return (
    <>
    {/*  */}
            {/* Sub Header */}
            <div className="absolute left-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Bottom Pink Blobs */}
        <div className="absolute left-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Top Green Blobs */}
        <div className="absolute left-[50%] top-[5%] transform -translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[50%] top-[5%] transform translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
              <div className="mt-20">
          
    
          {/* Button */}
          <motion.div
            className="flex justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1 }}
          >
            <motion.button
              className="relative bg-[#432DD7] w-[178px] h-[60px] text-white font-[Nunito] rounded-full text-center flex justify-center items-center"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              Our Services
            </motion.button>
          </motion.div>
    
          {/* Headings */}
          <motion.h2
            className="text-[28px] md:text-[64px] font-[700] text-center"
            style={{ fontFamily: "PT Sans" }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            Showcasing Our Creative Solutions
          </motion.h2>
    
          <motion.h2
            className="text-[#432DD7] font-[Allison] text-center text-[30px] md:text-[64px] font-[400] relative"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            with innovation, strategy, and design excellence.
          </motion.h2>
    
          {/* Description */}
          <motion.div
            className="items-center justify-center flex"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.7 }}
          >
            <h2 className="font-[Nunito] text-center text-[12px] md:text-[24px] md:w-[1048px]">
            Explore our portfolio of innovative digital solutions that have helped businesses transform and grow in the digital landscape.
            </h2>
          </motion.div>
        </div>
    <br /><br />
    <div className="w-full relative bg-[#0F172B] justify-between">
      {/*  */}
      <div className="md:pl-15 md:pt-15 p-5">
      <button className="bg-[#432DD7]  font-[Nunito] h-[50px] md:h-[67px] w-[150px] md:w-[200px] rounded-full text-white">Our Services</button>
      <h2 className="text-white font-[Nunito] text-[16px] p-2 max-w-[1200px] text-justify">We offer a comprehensive range of IT services to help your business grow and succeed in the digital world. From custom software development and cloud solutions to cybersecurity and UI/UX design, our expert team ensures seamless digital transformation. Partner with us to enhance efficiency, drive innovation, and stay ahead of the competition.</h2>
      </div>

      <ul className="">
        {services.map((items) => (
          <li key={items.id} className="sticky top-0 p-20 md:ml-15 ">
              <div className="w-full bg-[#0F172B] mt-10 flex-col md:flex-row flex">
                  <div className="w-[2px] md:h-[100vh] h-[80vh] mt-15 bg-white absolute left-10 top-0">
                    <div className="w-4 h-4 rounded-full right-[7px] relative bg-white"></div>
                  </div>
                  <div className="w-full  items-center">
                      <h2 className="text-white font-[Nunito]">{items.number}</h2>
                      <img src={items.iconImg} alt="" className="md:w-30 md:h-30 w-10 h-10"/>
                      <h2 className="md:text-[40px] text-[20px] font-[700]" style={{color:items.iconBg,fontFamily:'PT Sans'}}>{items.title}</h2>
                      <h1 className="text-white md:text-[40px] text-[20px] font-[400] font-[Allison]">{items.subtitle}</h1>
                      <h2 className="text-white font-[Nunito] text-[8px] md:text-[16px] text-justify">{items.description}</h2>
                  </div>
                  <div className="w-full relative">
                      <img src={items.illustration} alt="" className="xl:ml-30"/>
                  </div>
              </div>
          </li>
        ))}
      </ul>
    </div></>
  );
};

export default ServiceCard;


// const ServicesSection = () => {
//   return (
//     <section className="w-full bg-[#0D0D2B] py-12 px-4 sm:py-14 md:py-16 sm:px-6 md:px-8">
//       <motion.div
//         className="text-justify max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-4xl mx-auto ml-10"
//         initial={{ opacity: 0, x: -50 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1.5 }}
//       >
//         <motion.div
//           className="inline-block bg-[#432DD7] text-white px-5 py-2 sm:px-6 sm:py-3 md:px-7 md:py-3 rounded-full text-sm sm:text-base font-semibold mb-3"
//           initial={{ opacity: 0, x: -20 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1.2 }}
//         >
//           Our Services
//         </motion.div>
//         <p className="text-white mt-4 leading-relaxed text-base sm:text-lg md:text-xl">
//           We offer a comprehensive range of IT services to help your business grow and succeed in the digital world.
//           From custom software development and cloud solutions to cybersecurity and UI/UX design, our expert team ensures seamless digital transformation.
//           Partner with us to enhance efficiency, drive innovation, and stay ahead of the competition.
//         </p>
//       </motion.div>

//       {/* Call ServiceCard ONLY ONCE */}
//       <ServiceCard />
//     </section>
//   );
// };